module.exports = __webpack_public_path__ + "static/img/Horizontal shore 1,2 meter.e516def.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/Horizontal shore 1,2 meter.jpg
// module id = 82
// module chunks = 1